import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import classes from "./MultiRouterAccount.css";
import Box from "../../hoc/Box/Box";
import * as actions from "../../store/actions/index";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import Spinner from "../../components/UI/Spinner/Spinner";
import api from "../../axios-local-api";
import Collapsible from "react-collapsible";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import {
  FaInfoCircle,
} from "react-icons/fa";
import Toolbar from "../../components/Toolbar/Toolbar";
import RouterCard from "./RouterCard";
import PodCard from "./PodCard";

const MultiRouterAccount = (props) => {
  const accountNumber = sessionStorage.getItem("accountNumber");
  const accountStatus = 'Active';
  const [routerUpArrow, setRouterUpArrow] = useState(true);
  const [podUpArrow, setPodUpArrow] = useState(true);

  const dispatch = useDispatch();
  // const realEquipment = useSelector((state) => state.equipment.realEquipment)
  const multiRouterData = useSelector((state) => state.multiRouter.multiRouter);
  const allRouters = useSelector((state)=> state.multiRouter.multiRouter.routersDetails)
  const isLoading = useSelector((state) => state.multiRouter.loading);
  const isAssignPodRequestLoading = useSelector((state) => state.multiRouter.isAssignPodRequestLoading);
  const assignPodSuccess = useSelector((state) => state.multiRouter.assignPodSuccess)
  const assignPodFailure = useSelector((state) => state.multiRouter.assignPodFailure);
  const unClaimedPodSuccess = useSelector((state) => state.multiRouter.unClaimedPodSuccess)
  const unClaimedPodFailure = useSelector((state) => state.multiRouter.unClaimedPodFailure)
  const isunClaimedPodRequestLoading = useSelector((state) => state.multiRouter.isunClaimedPodRequestLoading)
  const successStatusMessage = useSelector((state) => state.multiRouter.successStatusMessage)
  const errorStatusMessage = useSelector((state) => state.multiRouter.errorStatusMessage)
  // console.log(">>>realEquipment",realEquipment)
  // console.log(">>>multiRouter", multiRouterData, isLoading)
  useEffect(() => {
    // dispatch(actions.initEquipment());
    dispatch(actions.getMultiRouter());
  }, []);

  useEffect(() => {
    if (successStatusMessage || errorStatusMessage) {
      setTimeout(() => {
        // console.log("test here")
        dispatch(actions.resetMultiRouterStatus())
      }, 10000)
    }
  }, [successStatusMessage, errorStatusMessage])
  
  const assignPods = (serialNumber, rMac, ssid) => {
    // console.log('RMACs', rMac )
    dispatch(actions.assignPods(serialNumber, rMac, ssid));
  }
  const onUnClaimedPods = (serialNumber, ssid) => {
    // console.log('UNCLAIMMM', serialNumber)
    dispatch(actions.unClaimedPods(serialNumber,ssid));
  }

  let rArrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
  if (routerUpArrow) {
    rArrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
  } else {
    rArrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
  }

  let pArrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
  if (podUpArrow) {
    pArrow = <MdKeyboardArrowUp color={'gray'} size={'30px'} />;
  } else {
    pArrow = <MdKeyboardArrowDown color={'gray'} size={'30px'} />;
  }



  const openAllRouters = (type, url) => {
    allRouters.forEach((rou, key) => {
      // console.log('LINK', key, `autoid${key}`)

      document.getElementById(`autoid${key}`).click()      // document.links[0].open()
 
    })

  }

  const routersDetails = multiRouterData?.networkTopology?.map((netTop, index) => {
    const { router, modem } = netTop;
    if (router) {
      // this.setState({ myArray: [...this.state.myArray, 'new value'] })
      return <RouterCard 
      accountNumber={accountNumber} 
      router={router} modem={modem} 
      key={index} 
      ind={index} 
      openDetails={openAllRouters} 
      onUnClaimedPods={onUnClaimedPods} 
      unClaimedPodSuccess={unClaimedPodSuccess}
      unClaimedPodFailure={unClaimedPodFailure}
      isunClaimedPodRequestLoading={isunClaimedPodRequestLoading}
      />
    }
  }).filter(Boolean);
  // setAllRouterIds(arr2)
  const routersCount = multiRouterData.networkTopology?.filter(topology => !!topology.router).length || 0;
  const podsCount = multiRouterData?.unclaimedPods?.length || 0;

  const podsDetails = multiRouterData?.unclaimedPods?.map((pod, index) =>
  (
    <PodCard
      pod={pod}
      key={index}
      networkTopology={multiRouterData?.networkTopology || []}
      assignPod={assignPods}
      assignPodSuccess={assignPodSuccess}
      assignPodFailure={assignPodFailure}
      isAssignPodRequestLoading={isAssignPodRequestLoading}

    />
  )
  );

  return (
    <Box>
      <main>
        <Toolbar
          showLogo={true}
          isAuth={props.isAuthenticated}
          userId={props.loggedinUserId}
        />
        <div className={classes.mraPage}>
          <div className={classes.container}>
            {(successStatusMessage || errorStatusMessage) && 
            <div id = 'ABWPodMSG'
              className={[classes.statusMessageContainer, errorStatusMessage ? classes.error : classes.success].join(" ")}
            >
              {successStatusMessage || errorStatusMessage}
            </div>}
            <div className={classes.accountDetailsSection}>
              <div className={classes.mraAccountInfo}>
                <span style={{ fontWeight: 'bold' }}>
                  <label id='ABWAccountNumber' className={classes.mraAccountNoLable}>
                    Account Number :{" "}
                  </label>
                  {accountNumber}
                </span>
                {/* <span  style={{ fontWeight: 'bold' }}>
                  <label className={classes.mraAccountStatusLable}>
                    Status :{" "}
                  </label>
                  {accountStatus} */}
                {/* </span> */}
              </div>
              {!isLoading && multiRouterData && !!routersCount && <div className={classes.mraViewAllDiv}>
                <button
                  id='openAllRouters'
                  className={classes.mraViewAll}
                  disabled={!routersCount}
                  onClick={() => { openAllRouters('all') }}
                >Open All In WIN</button>
              </div>}

            </div>
            <div className={[classes.mraAccountMsg, !routersCount && !isLoading ? classes.mraNoRouterAccountMessage: ""].join(" ")}>
              {!routersCount && !isLoading ? null : <span>
                <FaInfoCircle id='ABWMsgIcon' color="#38a9f9" size={24} />
              </span>
              }
              <span id="ABWMsg" className={classes.alertMessage}>
                {!routersCount && !isLoading ? "No SCP Routers":
                `This account has multiple routers. Please select a router or
                open all instances of WIN`}
              </span>
            </div>
            {isLoading ? <Spinner /> :
              <>
                {!!routersCount && <div className={classes.mraRouters}>
                  <Collapsible
                    transitionTime={100}
                    open={routerUpArrow}
                    onOpening={() => setRouterUpArrow(true)}
                    onClosing={() => setRouterUpArrow(false)}
                    trigger={
                      <Box>
                        <div className={classes.mraRoutersCollapse}>
                          <div className={classes.TitleArea}>
                            <h3 id='ABWRouters' style={{ paddingRight: 20, cursor: 'pointer' }}>
                              Routers ({routersCount})
                            </h3>
                            <button
                              id="mraRoutersArrow"
                              className={classes.OpenCloseButton}
                              style={{ float: 'right' }}
                              aria-label="open arrow"
                            >
                              {rArrow}
                            </button>
                          </div>
                        </div>
                      </Box>
                    }
                  >

                  </Collapsible>
                  <div className={classes.HorizontalSeparator} />
                  {routerUpArrow && routersDetails}
                </div>}
                <div className={classes.HorizontalSeparator} />
                {!!podsCount &&
                <div className={classes.mraPods}>
                  <Collapsible
                    transitionTime={100}
                    open={podUpArrow}
                    onOpening={() => setPodUpArrow(true)}
                    onClosing={() => setPodUpArrow(false)}
                    trigger={
                      <Box>
                        <div className={classes.mraPodsCollapse}>
                          <div className={classes.TitleArea}>
                            <h3 id='UnassignedPods' style={{ paddingRight: 20, cursor: 'pointer' }}>
                              Unassigned Extenders ({podsCount})
                            </h3>
                            <button
                              id="mraPodsArrow"
                              className={classes.OpenCloseButton}
                              style={{ float: 'right' }}
                              aria-label="open arrow"
                            >
                              {pArrow}
                            </button>
                          </div>
                        </div>
                      </Box>
                    }
                  >

                  </Collapsible>
                  <div className={classes.HorizontalSeparator} />
                  {podUpArrow && podsDetails}
                </div>}
              </>}

          </div>
        </div>

      </main>
    </Box>
  );
};

const mapStateToProps = (state) => ({
  
});

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorHandler(MultiRouterAccount, api));
